/* src/app/shared/components/confirm-dialog/confirm-dialog.component.scss */
.device-desktop {
  min-width: 1280px;
  overflow-x: auto;
}
.device-tablet {
  min-width: 1133px;
  overflow-x: auto;
}
.device-mobile {
  min-width: 390px;
  overflow-x: auto;
}
.header-h1 {
  font-family: var(--font-family) !important;
  font-weight: 300 !important;
  font-size: 2rem !important;
  color: var(--color-header-name) !important;
}
.header-h2 {
  font-family: var(--font-family) !important;
  font-weight: 700 !important;
  font-size: 1.875rem !important;
  color: var(--color-header-name) !important;
}
.header-h3 {
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 1.5rem !important;
  color: var(--color-header-name) !important;
}
.header-h4 {
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 1.125rem !important;
  color: var(--color-header-name) !important;
}
.header-h5 {
  font-family: var(--font-family) !important;
  font-weight: 700 !important;
  font-size: 1rem !important;
  color: var(--color-header-name) !important;
}
.header-h6 {
  font-family: var(--font-family) !important;
  font-weight: 700 !important;
  font-size: 0.8125rem !important;
  color: var(--color-header-name) !important;
}
.body-text {
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: var(--color-header-name) !important;
}
.small-body-text {
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 11.375px !important;
  color: var(--color-header-name) !important;
}
.text-link {
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 1rem !important;
  color: var(--color-secondary) !important;
  text-decoration: underline;
}
.text-link:hover {
  color: var(--color-hover) !important;
}
.text-link:visited {
  color: var(--color-visited) !important;
}
.small-text-link {
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 0.8125rem !important;
  color: var(--color-secondary) !important;
  text-decoration: underline;
}
.small-text-link:hover {
  color: var(--color-hover) !important;
}
.small-text-link:visited {
  color: var(--color-visited) !important;
}
.modal-header h2 {
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 400;
  color: var(--color-black);
  line-height: 22px;
  letter-spacing: 0px;
}
.modal-header h2 {
  font-weight: 700;
}
.modal-body .body-content .body-text,
.buttons .yes-button,
.buttons .no-button {
  font-family: var(--font-family);
  font-size: 16px;
  font-weight: 400;
  color: var(--color-black);
  line-height: 22px;
  letter-spacing: 0px;
}
:host {
  display: block;
  padding: 0;
  max-width: 562px;
  width: 100%;
}
.modal-container {
  padding: 24px;
  background-color: var(--color-order-dtls-bg);
  border-radius: var(--popup-header-border-radius);
  border: var(--border-width-popup) solid var(--color-white);
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
}
.modal-header h2 {
  font-size: var(--popup-header-font-size);
  line-height: 32px;
  font-weight: 600;
  margin: 0;
  color: var(--color-royal-purple);
}
:host-context(.device-mobile) .modal-header h2 {
  font-size: 18px;
}
.modal-header button mat-icon {
  font-size: 26px;
  color: var(--color-gray-40);
}
.modal-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.modal-body .body-content .body-text {
  margin-bottom: 10px;
}
.cancel-reason-section {
  margin-top: 16px;
}
.buttons {
  text-align: end;
  margin-top: 22px;
}
:host-context(.device-mobile) .buttons {
  display: flex;
  flex-direction: column;
  gap: 20px;
  text-align: unset;
  align-items: center;
}
.buttons .yes-button,
.buttons .no-button {
  padding-left: var(--padding-yes-no-button);
  padding-right: var(--padding-yes-no-button);
  border-radius: var(--border-radius-yes-no-button);
  border: 1px solid var(--color-royal-purple);
  width: 203px;
  font-weight: var(--font-weight-medium) !important;
  cursor: pointer;
  height: var(--height-close-button);
}
.buttons .yes-button:disabled,
.buttons .no-button:disabled {
  background-color: var(--color-disabled-bg, #e0e0e0);
  border-color: var(--color-disabled-border, #cccccc);
  color: var(--color-disabled-text, #999999);
  cursor: not-allowed;
  pointer-events: none;
}
:host-context(.device-mobile) .buttons .yes-button,
:host-context(.device-mobile) .buttons .no-button {
  width: 70%;
}
.buttons .yes-button {
  background-color: var(--color-white);
  color: var(--color-royal-purple);
  margin-right: 20px;
}
:host-context(.device-mobile) .buttons .yes-button {
  margin-right: 0;
}
.buttons .no-button {
  background-color: var(--color-royal-purple);
  color: var(--color-white);
}
.close-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  margin-right: -10px;
}
.close-button mat-icon {
  color: var(--color-gray-40);
  font-size: 22px;
}
/*# sourceMappingURL=confirm-dialog.component.css.map */
